import { useState } from 'react'
import { Box, Collapse, Group, Stack, Text, UnstyledButton } from '@mantine/core'
import { IconChevronDown, IconChevronRight, IconDatabase } from '@tabler/icons-react'
import { useQuery } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import { dbaConversasApi } from '@/api/dbaConversas'

/**
 * "Consultas ao @DBA" na lista do chat (spec 2026-10-31-dba-conversa-do-banco §3.2): as conversas
 * do banco aberto no editor, separadas das conversas de verdade e recolhidas por padrão. Só as
 * com atividade nos últimos 7 dias — as paradas saem de vista sem ser apagadas, e voltam quando a
 * pessoa reabre o banco no editor. Sem nenhuma, a seção nem aparece.
 */
export function ConsultasAoDba() {
  const navigate = useNavigate()
  const [aberto, setAberto] = useState(false)
  const { data } = useQuery({
    queryKey: ['dba-conversas', 'todas'],
    queryFn: () => dbaConversasApi.recentes(),
    staleTime: 60 * 1000,
  })
  const itens = data?.items ?? []
  if (itens.length === 0) return null
  return (
    <Box style={{ borderBottom: '1px solid var(--ai-border-light, var(--mantine-color-gray-2))' }}>
      <UnstyledButton onClick={() => setAberto((v) => !v)} px="md" py="xs" style={{ width: '100%' }}
        aria-expanded={aberto}>
        <Group gap={6} wrap="nowrap">
          {aberto ? <IconChevronDown size={14} /> : <IconChevronRight size={14} />}
          <IconDatabase size={14} />
          <Text size="xs" fw={600} c="dimmed">{`Consultas ao @DBA (${itens.length})`}</Text>
        </Group>
      </UnstyledButton>
      <Collapse in={aberto}>
        <Stack gap={0} pb={4}>
          {itens.map((c) => (
            <UnstyledButton key={c.conversation_id} onClick={() => navigate(`/chat/${c.conversation_id}`)}
              px="md" py={6} pl={36}>
              <Text size="sm" truncate>{c.titulo ?? `@DBA · ${c.db_identifier}`}</Text>
              <Text size="xs" c="dimmed" truncate>{c.tenant_nome ?? `tenant ${c.tenant_id}`}</Text>
            </UnstyledButton>
          ))}
        </Stack>
      </Collapse>
    </Box>
  )
}
